import { UsageTotals } from '../types/agentUsage';

/** Pure formatters and table classes for the admin agent-usage and margin surfaces. */

export const TABLE_TH =
  'px-4 py-2.5 text-left text-2xs font-semibold text-neutral-700 uppercase tracking-wider';
export const TABLE_TD = 'px-4 py-2.5 text-sm text-neutral-900 whitespace-nowrap';

/** Rate is derived here, not served: the API sends counts so the format is ours. */
export const failureRatePct = (t: UsageTotals): number =>
  t.runs > 0 ? Math.round((t.failed / t.runs) * 1000) / 10 : 0;

/** Round once up front so seconds can never display as "2m 60s". */
export const formatDuration = (secs: number | null): string => {
  if (secs === null || !Number.isFinite(secs)) return '—';
  const s = Math.round(secs);
  if (s < 60) return `${s}s`;
  return `${Math.floor(s / 60)}m ${s % 60}s`;
};

export const formatCost = (usd: number): string => {
  const abs = Math.abs(usd);
  const sign = usd < 0 ? '-' : '';
  return `${sign}$${abs > 0 && abs < 0.01 ? abs.toFixed(4) : abs.toFixed(2)}`;
};

export const formatRatio = (ratio: number | null): string =>
  ratio === null ? '—' : `${Math.round(ratio * 1000) / 10}%`;
